import { YesObject } from '@yes.technology/react-toolkit'

/*
  Checks if a value is a YesObject row.
*/
export function isYesObjectRow(value: unknown): value is YesObject {
  if (typeof value !== 'object' || value === null) {
    return false
  }
  if (!('uuid' in value)) {
    return false
  }
  const uuid = Reflect.get(value, 'uuid')
  return typeof uuid === 'string'
}

/**
 * Reads a relation column from a YesObject as a list of row objects (uuid + optional fields).
 */
export function relationObjectsAtColumn(
  obj: YesObject | undefined,
  column: string
): YesObject[] {
  if (!obj || !column) {
    return []
  }

  const raw = Reflect.get(obj, column)
  if (!Array.isArray(raw)) {
    return []
  }

  return raw.filter(isYesObjectRow)
}
